import React from 'react';
import './companyManagement.scss';

import { useAuth } from  '../../contexts/auth'; 
import CompanyCashFlow from './companyCashFlow.js';
import CompanyCashFlowTable from './companyCashFlowTable.js';
import ProjectsTab from './projectsTab.js';
import CompanyCostsTab from './companyCostsTab.js';
//import CompanyAccountingTab from './companyAccountingTab.js';

import { TabPanel, Item } from 'devextreme-react/tab-panel';

import { useState, useEffect, useCallback } from "react";

import { Button } from 'devextreme-react/button';
import Toolbar from 'devextreme-react/toolbar';



export default function CompanyManagementDetail(props) {

    const { user } = useAuth(); 

    function renderProjectsTab() {
        return <ProjectsTab dataInizio = {props.data.data.dataInizio} dataFine = {props.data.data.dataFineEffettiva} intermediario = {props.data.data.intermediarioId} />;
    }

    //function renderCompanyAccountingTab() {
    //     return <CompanyAccountingTab dataInizio = {props.data.data.dataInizio} dataFine = {props.data.data.dataFineEffettiva} intermediario = {props.data.data.intermediarioId} commessa = {props.data.data.id}/>;
    // }

    function renderCompanyCostsTab() {
        return <CompanyCostsTab dataInizio = {props.data.data.dataInizio} dataFine = {props.data.data.dataFineEffettiva} commessa = {props.data.data.id} />;
    }

    const onTabSelectionChanged = useCallback((e) => {
        //notify("The button was clicked");
        ;
    }, []);


    const renderForecastCFTab = () => {
        return (
            <div className={'mystats-container'}> 
                
                <div className={'mystats-title'}>
                    Cash Flow Forecast
                </div>
                <div className={'mystats-data'}>
                    <CompanyCashFlowTable commessa = {props.data.data.id} intermediario = {props.data.data.intermediarioId} dataInizio = {props.data.data.dataInizio} dataFine = {props.data.data.dataFineEffettiva} type = "Forecast"/>
                </div>

                <div className={'mystats-graph-data'}>
                    <CompanyCashFlow commessa = {props.data.data.id} intermediario = {props.data.data.intermediarioId} dataInizio = {props.data.data.dataInizio} dataFine = {props.data.data.dataFineEffettiva} type = "Forecast"/>
                </div>
         
            </div>
        )
    };

    const renderOriginalCFTab = () => {
        return (
            <div className={'mystats-container'}> 
                
                <div className={'mystats-title'}>
                    Cash Flow Original
                </div>
                <div className={'mystats-data'}>
                    <CompanyCashFlowTable commessa = {props.data.data.id} intermediario = {props.data.data.intermediarioId} dataInizio = {props.data.data.dataInizio} dataFine = {props.data.data.dataFineEffettiva} type = "Original"/>
                </div>

                <div className={'mystats-graph-data'}>
                    <CompanyCashFlow commessa = {props.data.data.id} intermediario = {props.data.data.intermediarioId} dataInizio = {props.data.data.dataInizio} dataFine = {props.data.data.dataFineEffettiva} type = "Original"/>
                </div>

                    
            </div>
        )
    };

    const renderActualCFTab = () => {
        return (
            <div className={'mystats-container'}> 
                
                <div className={'mystats-title'}>
                    Cash Flow Actual
                </div>
                <div className={'mystats-data'}>
                    <CompanyCashFlowTable commessa = {props.data.data.id} intermediario = {props.data.data.intermediarioId} dataInizio = {props.data.data.dataInizio} dataFine = {props.data.data.dataFineEffettiva} type = "Actual"/>
                </div>

                <div className={'mystats-graph-data'}>
                    <CompanyCashFlow commessa = {props.data.data.id} intermediario = {props.data.data.intermediarioId} dataInizio = {props.data.data.dataInizio} dataFine = {props.data.data.dataFineEffettiva} type = "Actual"/>
                </div>

                    
            </div>
        )
    };

    // const [projectValue, setProjectValue] = useState({});
    // const [realValue, setRealValue] = useState({});
    // const [transactions, setTransactions] = useState({});
    // const [activities, setActivities] = useState({});

    // const numberFormatter = new Intl.NumberFormat('it-IT', {
    //     style: 'decimal',
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2
    // });

    // useEffect(() => {

    //     const fetchData = async () => {
    
    //     const requestOptions = {
    //         headers: {
    //             Authorization: `Bearer ${user.token}`
    //         }
    //     };

    //     const prjId = props.data.key;

    //     const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
    //     var newUrl1 =  newServiceUrl1 + "/GetCompanyProjectValues/" + prjId;

    //     const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
    //     var newUrl2 =  newServiceUrl2 + "/GetCompanyRealValues/" + prjId;

    //     const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
    //     var newUrl3 =  newServiceUrl3 + "/GetTransactions/" + prjId;

    //     const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
    //     var newUrl4 =  newServiceUrl4 + "/GetPercActivities/" + prjId;
    
    //       try {
    
    //         const response1 = await fetch(newUrl1,requestOptions);
    //         const json1 = await response1.json();
    //         console.log(json1);
    //         setProjectValue(json1);

    //         const response2 = await fetch(newUrl2,requestOptions);
    //         const json2 = await response2.json();
    //         console.log(json2);
    //         setRealValue(json2);

    //         const response3 = await fetch(newUrl3,requestOptions);
    //         const json3 = await response3.json();
    //         console.log(json3);
    //         setTransactions(json3);

    //         const response4 = await fetch(newUrl4,requestOptions);
    //         const json4 = await response4.json();
    //         console.log(json4);
    //         setActivities(json4);
    
    //       } catch (error) {
    //         console.log("error", error);
    //       }
    //     };
    
    //     fetchData();
    //   }, []);

    const infoHint= "Creata da " + props.data.data.createBy + " il " + props.data.data.strCreateDate + "\n" + "Modificata da " + props.data.data.updateBy + " il " + props.data.data.strUpdateDate ;






    return (
    
    
        <div>
            <div className="project-title" align="left"> 
               <h2>Gestione {props.data.data.intermediario} {props.data.data.strDataInizio} -  {props.data.data.strDataFineEffettiva}</h2>  
            </div>
            
            <div className="project-button-refresh" align="right">     
                <Toolbar>
                    <Item location="after">
                       <Button className="offer-toolbar"
                       icon='refresh'
                       hint='Aggiorna'
                    />
                    </Item>
                    <Item location="after">
                       <Button className="project-toolbar"
                       icon='info'
                       hint= {infoHint}
                    />
                    </Item>              
                </Toolbar>
            </div>

            <div>
                <TabPanel    
                    showNavButtons={true}
                    adaptivityEnabled={true}
                    //onSelectionChanged={onTabSelectionChanged2}
                >
                   
                    <Item title="Forecast" render={renderForecastCFTab} />
                    <Item title="Original" render={renderOriginalCFTab}/>
                    <Item title="Actual"  render={renderActualCFTab}/>
                  
                </TabPanel>  
            </div>


            <div>
                <TabPanel    
                    onSelectionChanged={onTabSelectionChanged}
                >
                     <Item title="Commesse" render={renderProjectsTab} />  
                    
          
                </TabPanel>
                    
            </div>  
        </div> 
)};